var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SteemActionType } from '@popup/steem/actions/action-type.enum';
import { DynamicGlobalPropertiesUtils } from '@popup/steem/utils/dynamic-global-properties.utils';
import SteemUtils from '@popup/steem/utils/steem.utils';
import Logger from 'src/utils/logger.utils';
export const loadGlobalProperties = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const [globals, price, rewardFund] = yield Promise.all([
            DynamicGlobalPropertiesUtils.getDynamicGlobalProperties(),
            SteemUtils.getCurrentMedianHistoryPrice(),
            SteemUtils.getRewardFund(),
        ]);
        const props = { globals, price, rewardFund };
        const action = {
            type: SteemActionType.LOAD_GLOBAL_PROPS,
            payload: props,
        };
        dispatch(action);
        dispatch({
            type: SteemActionType.SET_APP_STATUS,
            payload: { globalPropertiesLoaded: true },
        });
    }
    catch (err) {
        Logger.error(err);
    }
});
